import { connect } from 'react-redux';
import { update } from '../../../store/auth';
import { actions as profileActions } from '../../../store/profile';

const AUTH_NOMFA = 'NOMFA';

function isMFAEnabled(preferredMFA) {
  return Boolean(preferredMFA && preferredMFA !== AUTH_NOMFA);
}

function mapStateToProps(state) {
  return {
    authUser: state.auth || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateMFA: async (preferredMFA) => {
      const action = await dispatch(profileActions.setMFA({ mfa: preferredMFA }));

      if (profileActions.setMFA.fulfilled.match(action)) {
        dispatch(
          update({
            '2faActive': preferredMFA !== AUTH_NOMFA ? preferredMFA.toLowerCase() : null,
            mfaEnabled: isMFAEnabled(preferredMFA),
            preferredMFA,
          })
        );

        return true;
      }

      throw action.error || new Error('Unable to update two-factor authentication.');
    },

    updatePhone: (phone) => {
      return dispatch(update({ phone }));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps);
